module.exports = {
  localization: {
    homeFont: '首页',
    productFont:"产品中心",
    schemeFont:"解决方案",
    caseFont:"成功案例",
    serveFont:"服务与支持",
    investorFont:"投资者关系",
    aboutFont: '关于我们',
    joinUsFont:"加入我们",
    productIntroduceFont:"深圳市今天国际物流技术股份有限公司，是一家专业的智慧物流·智能制造系统综合解决方案提供商，为生产制造、流通配送企业提供生产自动化及物流系统的规划设计、系统集成、软件开发、设备定制、电控系统开发、现场安装调试、客户培训和售后服务等一系列业务。",
    hardwareFont:"硬件设施",
    codeFint:"低代码平台",
    IIoTFont:"工业物联网平台（IIoT）",
    bigDataFont:"大数据开发平台",
    SRMFont:"供应商关系管理平台（SRM）",
    LMISFont:"物料管控平台系统（LMIS）",
    WMSFont:"仓库管理系统软件（WMS）",
    MASFont:"智能设备管理系统（MAS）",
    MESFont:"智能制造生产管理系统（MES）",
    AGVFont:"AGV",
    stackerFont:"堆垛机",
    closedFont:"边缘网关",
    EasyDataFont:"EasyData 数字孪生平台",
    allocationFont:"可配置软件开发平台",
    newProduct:"平台产品",
    newProduct1:"智能软件",
    newProduct2:"SaaS产品",
    newProduct3:"今天国际工业互联网平台",
    newProduct4:"可配置化软件开发平台",
    newProduct5:"数据采集控制开发平台",
    newProduct6:"大数据开发平台",
    newProduct7:"数字孪生开发平台",
    newProduct8:"今天国际供应商管理系统（SRM）",
    newProduct9:"今天国际智能仓库管理系统（WMS）",
    newProduct10:"今天国际智能仓库控制系统（WCS）",
    newProduct11:"今天国际物流管控系统（LMIS）",
    newProduct12:"今天国际智能运输管理系统（TMS）",
    newProduct13:"今天国际智能制造生产管理系统（MES）",
    newProduct14:"今天国际智能设备管理系统（MAS）",
    newProduct15:"在线数据可视化大屏开发软件（ScreenV）",
    newProduct16:"智慧物流协同管理系统（IICMS）",
    newProduct17:"智能制造生产管理系统（IMES）",
    newProduct18:"二维码统一应用系统",
    newProduct19:"今天云仓",
    newProduct20:"今天国际供应商关系管理系统",
    newProduct21:"今天国际客户关系管理系统",
    newProduct22:"今天国际报价专家",
    newProduct23:"今天国际报表助手",
    newProduct24:"今天国际在线报表",
    newProduct25:"今天文档",
    newProductData:'生产制造',
    newProductData1:'今天国际智能制造生产管理系统（MES）',
    newProductData2:'供应链管理',
    newProductData3:'今天国际供应商关系管理系统（SRM）',
    newProductData4:'今天云仓',
    newProductData5:'营销管理',
    newProductData6:'今天国际客户关系管理系统（CRM）',
    newProductData7:'今天国际报价专家',
    newProductData8:'智慧物流',
    newProductData9:'今天国际智能仓库管理系统（WMS）',
    newProductData10:'今天国际智能仓库控制系统（WCS）',
    newProductData11:'今天国际物流管控系统（LMIS）',
    newProductData12:'今天国际智能运输管理系统（TMS）',
    newProductData13:'智慧物流协同管理系统（IICMS）',
    newProductData14:"二维码统一应用系统",
    newProductData15:"智慧办公",
    newProductData16:"今天绩效管理系统",
    newProductData17:"今天报表可视助手BI",
    newProductData18:"今天文档管理系统",
    newProductData19:"今天任务",
    newProductData20:"智慧园区",
    newProductData21:"园区运营系统",
    newProductData22:"今天视频监控系统",
    newProductData23:"今天访客系统",
    newProductData24:"今天车辆系统",
    newProductData25:"设备管理",
    newProductData26:"今天设备云管系统",
    newProductData27:"AGV智能管控系统",
    newProductData28:"平台产品",
    newProductData29:"软件产品",
    newProductData30:"智能装备",
    newProductData31:"今天国际工业互联网平台",
    newProductData32:"一个具备四大使能工具的工业互联网平台，为数字化转型提供新架构、新能力、新方案、新价值",
    newProductData33:"可配置化软件开发平台",
    newProductData34:"积木式拼装搭建，帮助用户更好地设计并实现需求，让用户更专注业务逻辑，无需关注代码编写",
    newProductData35:"物联网数据采集开发平台",
    newProductData36:"嵌入了工业市场上多种通讯协议，支持数千种以上设备型号的驱动程序，实现设备快速接入",
    newProductData37:"大数据开发平台",
    newProductData38:"打造从数据存储治理到数据建模集成与分析应用全链路的一站式开发工具，安全高效完成数据应用",
    newProductData39:"数字孪生开发平台",
    newProductData40:"可视化拖拉拽构建方式，内置丰富3D模型，轻松完成数字孪生应用构建",
    newProductData41:"包含了叉取型AGV，定制属具型AGV、定制车体型AGV潜伏顶升型AGV，背驮型AGV、协作机器人等丰富的AGV产品",
    newProductData42:"包含了轻型堆垛机系列，中型堆垛机系列，重型堆垛机系列，弯轨堆垛机系列，特殊堆垛机系列等一系列堆垛机产品",
    newProductData43:"一个具备可配置化软件开发、数据采集控制开发、大数据开发、数字孪生开发等四大使能工具的强大、安全、稳定的工业互联网平台，为数字化转型提供新架构、新能力、新方案、新价值。",
    newProductData44:"大幅度提升系统开发效率",
    newProductData45:"快速广泛接入设备及数据采集",
    newProductData46:"高效安全治理及数据分析",
    newProductData47:"低成本构建数字孪生应用",
    newProductData48:"积木式拼装搭建，帮助用户更好地设计并实现需求 ，让用户更专注业务逻辑，无需关注代码编写",
    newProductData49:"嵌入了工业市场上多种通讯协议，支持数千种以上设备型号的驱动程序，实现设备快速接入",
    newProductData50:"打造从数据存储治理到数据建模集成与分析应用全链路的一站式开发工具，安全高效完成数据应用",
    newProductData51:"可视化拖拉拽构建方式，内置丰富3D模型，轻松完成数字孪生应用构建",
    newProductData52:"品质精湛",
    newProductData53:"创造无限可能",
    gardenSolveFont:"智慧物流园解决方案",
    factorySolveFont:"智慧工厂解决方案",
    logisticsSolveFont:"智慧物流解决方案",
    HomeTitleFong:"基于工业互联网的智慧物流解决方案提供商",
    HomeRunFong:"专注于数智化技术研究应用，为企业类客户量身打造智慧物流、智慧工厂、智慧物流园三大解决方案，助力企业实现数智化转型升级。",
    solveFont1:"全球智能制造服务提供商",
    solveFont2:"多维度解决方案 · 实现降本增效",
    solveFont3:"产品流解决方案",
    solveFont4:"服务企业企业，主要生产对接，连接物工艺，连接物生产间，解决生产车间现实生产各个环节的智能化存储、抽选、搬运、传送等功能。",
    solveFont5:'我们的客户',
    seeFont:"了解详情",
    productFont1:"产品与服务",
    productFont2:"智能软件",
    productFont3:"智能装备",
    productFont4:"软件产品矩阵",
    productFont5:"可配置化开发平台",
    productFont6:"资源即配即用",
    productFont7:"丰盛的开箱即用组件",
    productFont8:"可视化业务编排设计",
    productFont9:"数字孪生开发平台",
    productFont10:"配置开发构建3D",
    productFont11:"丰盛的3D模型资源",
    productFont12:"方便有效的数据接入",
    productFont13:"数据可视化平台",
    productFont14:"设置多种图表库",
    productFont15:"支持多种数据源接入",
    productFont16:"数据处理",
    productFont17:"大数据开发平台",
    productFont18:"数据集开发",
    productFont19:"数据资源",
    productFont20:"算法开发",
    productFont21:"数据服务",
    productFont22:"底层数据支持",
    productFont23:"设备云管平台",
    productFont24:"通过网络关盒和集成开发的协议将设备接入平台，上报设备数据到云端，实时数据流转、存储、分析和实时监控",
    productFont25:"数据采集控制开发平台",
    productFont26:"加入了工业市场上多种通信协议，支持数以千种以上设备型号的驱动程序，实现设备快速接入。",
    productFont27:"灵活的本地私有化部署",
    productFont28:"了解更多",
    productFont29:"堆垛机是高架立体库存取单元货物的专用起重设备，可在安全、高密度、高能效的存储结构中快速获取托盘、料箱和其他大宗货物，可提高仓库面积和空间利用率及仓储系统作业效率，实现自动化出入库，满足各种存储需求。今天国际为服务于不同场景使用的客户，自主研发了多个系列，共十多款堆垛机，满足客户使用需求。",
    productFont30:"工业移动机器人（AGV）是一种实现物料无人化搬运、堆码垛的智能物流设备。通过激光导引或电磁导引等方式，按设定的导引路线行进，能在生产车间、仓库和配送中心自动搬运输送，具有安全保护及各种移栽功能，无需人工驾驶，能为企业提高生产力，降低劳动成本。结合不同的使用场景，目前今天国际已推出多个系列，二十多款AGV产品，个性化服务于不同需求的客户。",
    platformFont:"平台能力指标及资质，成为客户可信赖的品牌",
    platformFont1:"我们很高兴为我们的客户提供内部物流服务。",
    platformFont2:"连接设备",
    platformFont3:"工业APP",
    platformFont4:"工业模型",
    platformFont5:"核心资质",
    platformFont6:"台",
    platformFont7:"个",
    advisoryFont:"公司资讯",
    advisoryFont1:"新闻中心",
    advisoryFont2:"查看更多",
    advisoryFont3:"视频中心",
    footerFont:"周一至周五 09:00 - 18:00",
    footerFont1:"股票代码",
    footerFont2:"今天国际（股票简称）",
    footerFont3:"友情链接：",
    footerFont4:"中国烟草资讯网",
    footerFont5:"高工锂电网",
    footerFont6:"物流技术与应用",
    footerFont7:"中国物流与采购联合会",
    footerFont8:"今天SRM",
    footerFont9:"钉钉服务窗",
    footerFont10:"微信公众号",
    footerFont11:"深圳市今天国际物流技术股份有限公司 版权所有",
    footerFont12:" 粤ICP备12074812号 ",
    footerFont13:"Copyright © 2000-",
    footerFont15:' NTI.All Rights ReserVed. By 今 天 国 际',
    footerFont14:'邮箱地址',
    solveProjectFong:"全面感知融合协同智能建设智慧工厂，将巨量数据和信息，变为对业务的洞察与知识；通过相关应用场景匹配的数字孪生智能分析和预测，提高投产率及其可靠率，确保生产过程实时优化，提高企业生产实时决策能力，实现流程管理精益化和数字化。",
    solveProjectFong1:"行业痛点洞察",
    solveProjectFong2:"数据孤岛",
    solveProjectFong4:"业务系统过多，数据接口独立，难以协同",
    solveProjectFong5:"业务协同差", 
    solveProjectFong6:"缺乏数据治理，导致大量跨系统的重复人工操作",
    solveProjectFong7:"缺乏数驱力", 
    solveProjectFong8:"决策效率低，无法通过数据进行决策",
    solveProjectFong9:"业务框架",
    solveProjectFong10:"方案价值",
    solveProjectFong11:"智能排产",
    solveProjectFong12:"工艺参数调优",
    solveProjectFong13:"生产仿真",
    solveProjectFong14:"设备健康管理",
    solveProjectFong15:"查看详情",
    solveProjectFong16:"利用先进的互联网、物联网、大数据分析等技术手段构建起一个智慧化的园区生态系统，实现了园区基础设施和公共服务资源的高度互联、信息共享和协同创新。",
    solveProjectFong17:"智能运营",
    solveProjectFong18:"指挥调度",
    solveProjectFong19:"物流管控",
    solveProjectFong20:"智慧消防",
    solveProjectFong21:"便捷通行",
    solveProjectFong22:"聚焦企业的瓶颈资源，针对人员技能、产能、原料供应、工艺等等关键因素采用倒排或预测的形式，确保排产的精准性",
    solveProjectFong23:"在产前、产中监测关键工艺参数并进行预警与分析，确保生产过程工艺参数与阈值实时比对",
    solveProjectFong24:"通过数据+模型融合，在虚拟环境中模拟生产各要素进行实时仿真，并进行动态验证，实现生产实时监控、预测、回溯",
    solveProjectFong25:"监控设备运行状态、参数、异常和运行时长，及时预测或干预设备状态，防止非计划性停机",
    solveProjectFong26:"集成园区人机事物全要素信息，统一资源调度，基于GIS/3D技术等实时呈现园区整体运行状况，提供园区驾驶舱",
    solveProjectFong27:"应急事件的指挥调度，支持事件提前预警并主动下推驾驶舱，匹配应急预案",
    solveProjectFong28:"集成物流在途管控、路线优化、车辆调度、入园调度等功能，提高物流作业效率",
    solveProjectFong29:"依托指挥调度中心，借助园区各种监控全天候全方位预警，支持设备安消防联动",
    solveProjectFong30:"提供人员、车辆的通行规划，结合UWB技术实现园内对象实时定位，精准导航",
    solveProjectFong31:"主要面向生产制造和流通配送两大类型的客户，提供智慧物流和智能制造系统工程的一站式服务，帮助客户实现生产或流通过程中物料的存储、搬运、输送、分拣、配送等环节的智能化作业和信息化管理，并为企业生产运行、管理、控制提供实时支持，达到生产制造过程的自动化、信息化、智能化。",
    solveProjectFong32:"透明度低",
    solveProjectFong33:"敏捷性弱",
    solveProjectFong34:"效率低",
    solveProjectFong35:"无法实时直观感知物流作业过程、设施健康状况，关键指标状况等，跟踪追溯难",
    solveProjectFong36:"通信能力不足、内外部协同性不足、数据挖掘分析不足，无法快速响应应急事件",
    solveProjectFong37:"依赖人为调度机制、人为干预控制方式、人为作业模式，无法满足仓储及运输需求",
    solveProjectFong38:"存储",
    solveProjectFong39:"搬运",
    solveProjectFong40:"输送",
    solveProjectFong41:"分拣",
    solveProjectFong42:"配送",
    solveProjectFong43:"智能仓储，提高空间利用",
    solveProjectFong44:"自动化设备，高效作业",
    solveProjectFong45:"智能输送，灵活响应",
    solveProjectFong46:"智能分拣，高准确率",
    solveProjectFong47:"精确调度，优化网络",
    solveProjectFong48:"利用物联网技术与大数据分析，实现精确库存管理，提升空间利用率。",
    solveProjectFong49:"引入自动引导车(AGV)与智能机器人，提高搬运效率，确保作业安全。",
    solveProjectFong50:"采用模块化设计，实现自动调整运输路线，快速、准确、安全地运输货物。",
    solveProjectFong51:"结合图像识别技术与机器学习算法，提高分拣准确率与效率，降低成本。",
    solveProjectFong52:"整合实时路况信息与优化算法，提供最佳配送路线，确保货物快速、准时送达。",
    immediately:"立即咨询",
    succeedFont:"客户成功案例",
    succeedFont1:"成功交付上千项目，助力众多行业客户实现智能升级",
    succeedFont2:"客户评价",
    succeedFont3:"精准快速交付",
    succeedFont4:"售后响应及时",
    succeedFont5:"行业经验丰富",
    succeedFont6:"专业能力强大",
    succeedFont7:"细分行业",
    succeedFont8:"省份",
    succeedFont9:"应用场景",
    succeedFont10:"合作伙伴",
    succeedFont11:"赋能数字化转型",
    succeedFont12:"提交信息，工作人员将在24小时内与您联系",
    succeedFont13:"联系人",
    succeedFont14:"联系电话",
    succeedFont15:"所在城市",
    succeedFont16:"备注",
    succeedFont17:"确 定",
    succeedFont18:"取 消",
    serviceSupportFont:"今天国际服务与支持",
    serviceSupportFont1:"提供最专业完善的售后服务与技术支持",
    serviceSupportFont2:"服务优势",
    serviceSupportFont3:"通过数字孪生系统实现预防预测维护",
    serviceSupportFont4:"通过自建备件系统实现备件高效供应",
    serviceSupportFont5:"通过服务模式创新实现定制化售后服务",
    serviceSupportFont9:"服务流程方案标准化",
    serviceSupportFont10:"服务体系",
    serviceSupportFont11:"完善的售后服务体系",
    serviceSupportFont12:"今天国际以“专业设计、个性服务、创造价值”为服务理念，建立了六级保障售后服务体系。从细节做起，在服务中精益求精，为客户提供专业、高效的售后服务。",
    serviceSupportFont13:"7天24小时贴身电话服务",
    serviceSupportFont14:"提供7*24小时免费电话服务热线，随时贴身服务，为客户排忧解难。全国售后服务热线：400-6136-656。",
    serviceSupportFont15:"远程在线维护系统",
    serviceSupportFont16:"系统在线远程维护，专业的技术支持，无地域之隔的高效服务。",
    serviceSupportFont17:"定期巡防维护",
    serviceSupportFont18:"定制定期巡防、维护计划，实时追踪设备使用情况，保障客户利益。",
    serviceSupportFont19:"客户自主维护",
    serviceSupportFont20:"始终坚持“客户自主维护”的原则，在不同阶段对客户进行技术培训，培养客户自主维护能力。",
    serviceSupportFont21:"本地化技术支持",
    serviceSupportFont22:"提供进口设备本地化技术服务及在主要项目地设立办事处，为客户降低维护成本，提高客户效益。",
    serviceSupportFont23:"服务网点",
    serviceSupportFont24:"公司总部",
    serviceSupportFont25:"地址：深圳市龙岗区宝龙街道翠宝路26号今天国际科技园",
    serviceSupportFont26:"销售部电话：0755-25161222",
    serviceSupportFont27:"深圳罗湖",
    serviceSupportFont28:"地址：深圳市罗湖区笋岗东路宝安广场A座10F",
    serviceSupportFont29:"销售部电话：0755-25161222",
    serviceSupportFont30:"售后服务电话：0755-25161222",
    serviceSupportFont31:"上海子公司",
    serviceSupportFont32:"地址：上海市闵行区申滨南路938号G栋501",
    serviceSupportFont33:"销售部电话：021-34710702",
    serviceSupportFont34:"售后服务电话：021-34710702",
    serviceSupportFont35:"武汉分公司",
    serviceSupportFont36:"地址：湖北省武汉市江汉区万松街街道商务中路与珠江路交叉口东北方向120米泛海国际SOHO城6栋2008",
    serviceSupportFont37:"销售部电话：027-83608288",
    serviceSupportFont38:"售后服务电话：0755-25161222",
    serviceSupportFont39:"合肥办事处",
    serviceSupportFont40:"地址：合肥市政务区祁门路与潜山路交叉口新地中心C座1001室",
    serviceSupportFont41:"销售部电话：0551-63524756 、0551-63524856 、 0551-63524956",
    serviceSupportFont42:"售后服务电话：0551-63524856",
    serviceSupportFont43:"厦门分公司",
    serviceSupportFont44:"地址：厦门市思明区莲岳路189号武夷工贸8号楼西侧401室",
    serviceSupportFont45:"销售部电话：0755-25161222",
    serviceSupportFont46:"售后服务电话：0755-25161222",
    serviceSupportFont47:"昆明办事处",
    serviceSupportFont48:"地址：云南省昆明市西山区万达双塔南塔3202",
    serviceSupportFont49:"销售部电话：0871-63111322",
    serviceSupportFont50:"售后服务电话：0871-63111322",
    serviceSupportFont51:"服务范围",
    serviceSupportFont52:"技术支持",
    serviceSupportFont53:"我司配置专业的技术支持团队，通过电话、邮件、远程接入和现场等方式对客户提供快捷有效的技术支持，修复系统故障。",
    serviceSupportFont54:"备件服务",
    serviceSupportFont55:"我司建立了自己的备件库，并与各物流系统设备的供应商建立了备件服务协议，以缩短备件采购周期，并确保备件供应的连续性和升级后的可替代性。同时，还提供备件的更换服务。",
    serviceSupportFont56:"系统年度维护服务",
    serviceSupportFont57:"我司对物流系统提供年度维护服务，通过1年1次或2次的系统深度维护，消除系统的各类隐患，确保系统处于最佳状态，安全稳定运行。",
    serviceSupportFont58:"系统升级改造服务",
    serviceSupportFont59:"我司配置专业的技术团队，协助客户对原有系统进行升级改造，优化系统性能，满足新的需求。",
    serviceSupportFont60:"培训服务",
    serviceSupportFont61:"我司针对客户提供各类培训服务，包括操作培训、维护培训、控制培训和信息培训等。",
    serviceSupportFont62:"驻场服务",
    serviceSupportFont63:"我司可安排专业的技术工程师长期驻守现场，在确保物流系统安全稳定运行的同时，通过现场培训和技术指导，提升客户的操作维护水平。",
    serviceSupportFont64:"全国售后服务热线：400-6136-656",
    agvFont:"AGV设备详情",
    agvFont0:"我们提供的方案",
    agvFont1:"工业移动机器人AGV",
    agvFont2:"工业移动机器人（AGV）是一种实现物料无人化搬运、堆码垛的智能物流设备。通过激光导引或电磁导引等方式，按设定的导引路线行进，能在生产车间、仓库和配送中心自动搬运输送，具有安全保护及各种移栽功能，无需人工驾驶，能为企业提高生产力，降低劳动成本。结合不同的使用场景，目前今天国际已推出多个系列，二十多款AGV产品，个性化服务于不同需求的客户。",
    agvFont3:"一、叉取型AGV",
    agvFont4:"该系列AGV采用单舵轮形式的底盘结构，运动灵活稳定； 应用场景广，可适用于地堆、不同高度的站台和多种货架类型。",
    agvFont5:"二、定制属具型AGV",
    agvFont6:"基于标准型叉车的结构，定制不同的属具类型，可适应于不同类型的货物搬运，如特殊的托盘尺寸、纸卷轴、箱式货物、双托盘搬运。",
    agvFont7:"三、定制车体型AGV",
    agvFont8:"定制化的车型结构，应用于有特殊要求的场景，如狭窄巷道或承载能力较弱的地面等。",
    agvFont9:"四、潜伏顶升型AGV",
    agvFont10:"准化的差速驱动底盘结构，运动灵活，行走速度最高可达2m/s；搭配可定制化的顶升机构与对接平台；适用于带货架的直接搬运、对接输送机站台以及密集型货架仓储模式",
    agvFont11:"五、背驮型AGV",
    agvFont12:"不同形式的底盘结构，搭载不同类型的移载机构；可适用于多种站台，支持多种对接方式。",
    agvFont13:"六、协作机器人",
    agvFont14:"标准化的驱动底盘结构，运动灵活；行走速度最高可达1.7m/s，搭配可定制化的机械手；可以在协作区域内直接与设备或人进行交互、满足人机协作生产需求。",
    agvFont15:"AGV类别",
    popFont:"大数据开发平台",
    popFont1:"OT数据采集平台",
    popFont2:"设备云管平台",
    popFont3:"今天SRM",
    popFont4:"今天云仓",
    popFont5:"园区管理系统",
    popFont6:"数字孪生平台",
    popFont7:"BI报表助手",
    popFont8:"可配置化开发平台",
    popFont9:'今天国际工业互联网平台',
    noDataFont:"暂无数据",
    noDataFont1:"暂无招聘信息",
    aboutFont1:"智能制造解决方案服务提供商",
    aboutFont3:"使命",
    aboutFont4:"推进智能制造，助力工业4.0",
    aboutFont5:"愿景",
    aboutFont6:"做国内领先的智能制造践行者",
    aboutFont7:"价值观",
    aboutFont8:"同心、同德、同创",
    aboutFont9:"公司介绍",
    aboutFont10:"发展历程",
    aboutFont11:"资质荣誉",
    aboutFont12:"社会责任",
    aboutFont13:"企业文化",
    aboutFont14:"创始人致辞",
    aboutFont15:"新闻中心",
    aboutFont16:"深圳市今天国际物流技术股份有限公司（简称：今天国际，股票代码：300532）是一家专业的智慧物流·智能制造系统综合解决方案提供商，成立于2000年，注册资本3.07亿。下设多家子公司，包括深圳市今天国际软件技术有限公司、深圳市今天国际智能机器人有限公司、上海今天华峰智能系统有限公司、香港今天国际物流科技有限公司、深圳市今天国际智能制造技术开发有限公司等，公司在上海、武汉、香港、合肥、昆明、厦门等城市建立了分支机构及区域技术服务中心，形成了覆盖全国的营销网络和技术服务体系。",
    aboutFont17:"今天国际以“让物联科技更智慧”为企业使命，专注于数智化技术研究应用，为企业类客户量身打造生产物流解决方案、配送中心解决方案、智能工厂解决方案、供应链信息化解决方案，提供方案设计、系统集成、设备选型、软件开发、电气控制、安装调试、培训及售后的一站式全流程服务，为客户实现生产和物流环节的自动化无人作业，柔性化生产，资源优化配置，数据互联互通、高效协同管理等，从而帮助客户提高效率，降低成本，提升管理水平，开启工业4.0和智能制造之路。",
    aboutFont18:"今天国际深耕智慧物流和智能制造20余载，服务覆盖30多个行业，客户遍布于烟草、新能源、石油化工、机械制造、航空航天、汽车高铁、电力电气、生物医药、食品饮料、生鲜冷链、大型商超、通信电子、家居日化等领域。公司业务已遍及全国各地，更走向海外市场，赢得广大客户的信赖与认可。",
    aboutFont19:"在专利和资质方面，今天国际已拥有400多项产品著作权和专利权，获得ISO9001、ISO14000、ISO/IEC27001、ISO20000体系认证。在软件和设备研发方面，已通过CMMI（软件能力成熟度模型集成）最高等级5级认证，并获得首张国产叉式AGV全功能指令认证CE证书。同时，公司是国家级高新技术企业、广东省工程技术研究中心、深圳市重点（技术型）物流企业、深圳市仓储智能化工程技术研究开发中心、深圳市5G智慧物流和智能制造示范单位、中德智能技术博士研究院理事成员单位等，全资子公司今天软件、今天机器人荣获国家级专精特新“小巨人”企业认定。",
    aboutFont20:"类别",
    aboutFont21:"技术专利",
    aboutFont22:"资格证书",
    aboutFont23:"荣誉奖项",
    aboutFont24:"创始人 邵健伟先生",
    aboutFont26:"日出东方，叩启穹庐。世纪之初，在南海之滨的深圳，今天国际秉承拓荒牛精神，怀揣科技立业的理想筑梦启航，历经二十多年打拼，一路披荆斩棘，厚积薄发，发展为我国A股第一家物流系统集成商，来之不易。",
    aboutFont27:"在日新月异的产业变革浪潮中，今天国际以开放的心态、专注的精神，以“让物联科技更智慧”为使命，在技术研发上攻坚克难，在核心竞争力上积攒优势，在企业管理上沉稳掌舵，致力于将最前沿的智能系统技术应用到物流系统和工业生产中，为客户提供智慧物流和智能制造的系统解决方案，助力于实现中国制造的智能化转型升级。",
    aboutFont28:"岁月不居，天道酬勤。我们正挥戈迈步，向一个由5G、大数据、互联网、云计算、人工智能构筑的智能社会新时代加速前进。我们必须放眼世界，面向未来，抓住新一轮科技革命的产业转型发展机遇，开启互联互通、人机共存、人机共智的新时代。未来的竞争属于平台共建与资源整合的竞争，汇聚资源，凝聚智慧，方有更大的生存空间与竞争力，实现共融、共创、共赢。",
    aboutFont29:"使命呼唤担当，梦想照亮未来。怀揣感恩之心，今天国际将矢志不移地做有责任心的企业，奋力担当，对客户尽诚信之责，对员工尽如家之责，对股东尽勉励之责，对社会尽感恩职责，携手共进，奋力远航。",
    aboutFont30:"公司新闻",
    aboutFont31:"市场活动",
    aboutFont32:"公司期刊",
    aboutFont33:"关于公司",
    aboutFont34:"企业文化",
    aboutFont35:"资讯",
    aboutFont36:"企业介绍",
    aboutFont37:"联系我们",
    aboutFont38:"总机：",
    aboutFont39:"采购：",
    aboutFont40:"售后：",
    aboutFont41:"展会&媒体：",
    aboutFont42:"下载中心",
    aboutFont43:"销售：",
    pilerFont:"堆垛机设备详情",
    pilerFont1:"堆垛机是高架立体库存取单元货物的专用起重设备，可在安全、高密度、高能效的存储结构中快速获取托盘、料箱和其他大宗货物，可提高仓库面积和空间利用率及仓储系统作业效率，实现自动化出入库，满足各种存储需求。今天国际为服务于不同场景使用的客户，自主研发了多个系列，共十多款堆垛机，满足客户使用需求。",
    pilerFont2:"一、轻型堆垛机系列",
    pilerFont3:"该系列堆垛机具有机身重量轻、运行速度快等特点；广泛运用于料箱、纸箱、工装载具的搬运；多用于新能源、医药、 商业烟草、物流等行业。",
    pilerFont4:"二、中型堆垛机系列",
    pilerFont5:"该系列堆垛机通过对机身结构的优化设计，达到最优性价比；应用行业广泛；满足客户不同重量货物的搬运需求。",
    pilerFont6:"三、重型堆垛机系列",
    pilerFont7:"该系列堆垛机制造工艺相对较复杂、结构强度高；设计中根据现场环境和工况选择堆垛机的立柱类型。",
    pilerFont8:"四、弯轨堆垛机系列",
    pilerFont9:"该系列堆垛机制造工艺相对较复杂、结构强度高；可满足不同效率、不同搬运场景的应用。",
    pilerFont10:"五、特殊堆垛机系列",
    pilerFont11:"该系列堆垛机多为非标设计，制造工艺相对较复杂，满足客户个性化需求；满足用户高温、低温环境的货物搬运及超长、超宽、圆柱形等非常规货物的搬运或配合子母车实现多排货物的存储。",
    pilerFont12:"堆垛机类型",
    video:"视频中心",
    homeFont1:"园区智慧运营是以“智慧”为核心要素，将园区分散的基础设施、空间、资产等资源进行整合和重构，挖掘和释放资源潜力",
    homeFont2:"智慧工厂作为工业4.0的重要实践，正渐渐成为智能制造的领路人",
    homeFont3:"物流环节作为企业供应、制造和交付环节的重要联结纽带，智慧物流成为了物流行业新的风向标",
    homeFont4:"联系",
    homeFont5:"成立",
    homeFont6:"行业",
    homeFont7:"大型项目案例",
    homeFont8:"员工",
    joinFont:"加入我们",
    joinFont1:"工作地点",
    joinFont2:"职位类别",
    joinFont3:"职位",
    joinFont4:"地点",
    joinFont5:"发布时间",
    joinFont6:"投递简历",
    joinFont7:"姓名",
    joinFont8:"电话",
    joinFont9:"邮箱",
    joinFont10:"上传",
    joinFont11:"上传文件简历",
    joinFont12:"点击上传或接拖拽文件，系统将自动动解析并填充支持html,htm,pdf,doc,docx,txl,xls,xlsx,mhl,rtf格式",
    joinFont13:"请填写姓名",
    joinFont14:"请填写电话",
    joinFont15:"请填写邮箱",
    joinFont16:"发送",
    joinFont17:"请输入联系人",
    joinFont18:"请输入联系电话",
    joinFont19:"请选择所在城市",
    joinFont20:"请输入备注",
    joinFont21:"公司名称",
    joinFont22:"行业",
    joinFont23:"需求描述",
    joinFont24:"请输入公司名称",
    joinFont25:"请输入行业",
    joinFont26:"请输入需求描述",
    load:"加载完成",
    more:"加载更多",
    all:"全部",
    stockmarket:"股票行情",
    secretaries:"董秘邮箱",
    investorNews:"定期报告",
    notice:"公司公告",
    interact:"互动交流",
    fax:"联系传真",
    email:"电子邮箱",
    site:"通信地址",
    code:"邮政编码",
    contactAddress:"深圳市龙岗区宝龙街道翠宝路26号今天国际科技园",
    pdf:"PDF下载",
    submitName:"身份验证",
    locationData:"地址：",
    productCenter:"仓储物流",
    productCenter1:"AGV智能监控",
    productCenter2:"计费管理系统",
    productCenter3:"设备云管",
    productCenter4:"智慧物流协同管理系统",
    productCenter5:"仓库管理系统",
    productCenter6:"订单管理系统",
    productCenter7:"智能盘点系统",
    productCenter8:"运输管理系统",
    productCenter9:"仓库执行系统",
    productCenter10:"云仓便存",
    productCenter11:"数字月台",
    productCenter12:"智慧园区",
    productCenter13:"智能家居",
    productCenter14:"园区管理",
    productCenter15:"智慧安防",
    productCenter16:"智慧车场",
    productCenter17:"车辆管理",
    productCenter18:"今天访客",
    productCenter19:"企业应用",
    productCenter20:"报价系统",
    productCenter21:"内容管理平台",
    productCenter22:"主数据管理",
    productCenter23:"绩效管理",
    productCenter24:"PMO",
    productCenter25:"今天SRM",
    productCenter26:"平台工具",
    productCenter27:"BI助手",
    productCenter28:"数据交换平台",
    productCenter29:"数据处理工具",
    productCenter30:"智能魔方平台",
    productCenter31:"物联网数据采集开发平台",
    productCenter32:"报表助手",
  }
}


//////////////////
// WEBPACK FOOTER
// ./static/lang/zh-CN.js
// module id = J71k
// module chunks = 28